<div
  class="w-[427px] h-full bg-white rounded-3xl border-4 border-surface-300 border-dashed
             flex flex-col justify-center items-center gap-2.5 text-center p-6 "
  [ngClass]="{'cursor-pointer': !disabled()}"
  (click)="openFileDialog()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <i class="fa-light fa-cloud-arrow-up text-4xl"></i>
  <div class="text-surface-900 text-base font-medium">
    Browse and choose a file or drag & drop it here
  </div>
  <div class="text-surface-400 text-sm font-medium">
    JPG, PNG, PDF, XLS and DOC formats up to 10MB
  </div>
  <p-button
    label="Browse..."
    [disabled]="disabled()"
    (onClick)="$event.stopPropagation(); openFileDialog()"
  ></p-button>

  <input
    #fileInput
    type="file"
    class="hidden"
    multiple
    accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx"
    (change)="onFileSelected($event)"
  />
</div>
